var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('RightMenu',{staticClass:"sticky-note-menu",attrs:{"menu-visible":_vm.stickyNoteMenuVisible,"menu":_vm.STICKY_NOTE_MENU}})}
var staticRenderFns = []
export { render, staticRenderFns }